module.exports = __webpack_public_path__ + "media/images/favicons/favicon-32x32-8ecc7a10d38720515be2363846a9ad14.png";